import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useIsMobile } from '@/hooks/use-mobile';
import { useAuth } from '@/hooks/useAuth';
import {
  LandingNav,
  HeroSection,
  ProblemSection,
  FeaturesSection,
  FocusBreathAnimation,
  TestimonialsSection,
  PricingSection,
  FooterSection,
} from '@/components/landing';

export default function Landing() {
  const { user } = useAuth();
  const isMobile = useIsMobile();
  const [isReady, setIsReady] = useState(false);

  // Small delay to let the useIsMobile hook initialize
  useEffect(() => {
    const timer = setTimeout(() => setIsReady(true), 50);
    return () => clearTimeout(timer);
  }, []);

  // Default to dark mode for landing page
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    if (!savedTheme) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    }
  }, []);

  // If on mobile or logged in, redirect appropriately
  if (isReady && (isMobile || user)) {
    return <Navigate to={user ? "/app" : "/auth"} replace />;
  }

  // Show nothing while determining device type (splash screen is showing anyway)
  if (!isReady) {
    return null;
  }

  // Desktop: show landing page
  return (
    <div className="min-h-screen bg-background">
      <LandingNav />
      <main id="main-content">
        <HeroSection />
        <ProblemSection />
        <FeaturesSection />
        <FocusBreathAnimation />
        <TestimonialsSection />
        <PricingSection />
      </main>
      <FooterSection />
    </div>
  );
}
